export default __webpack_public_path__ + "media/images/react_icons/tv-e4816765c3a980b11b62ac993b6b8e03.svg";